let routes = [
  {
    path:'/selfTtest',
    name:'selfTtest',
    component:() => import('@/views/selfTtest/selfTtest/selfTtest'),
    meta:{
      title: '健康自测',
    },
  },
	{
		// 血压
		path: '/bloodText',
		name: 'bloodText',
		component: () => import('@/views/selfTtest/RecorData/RecorData.vue'),
		meta: {
			title: '血压',
			keepAlive: true
		}
	},
	{
		// 血糖
		path: '/bloodsugar',
		name: 'bloodsugar',
		component: () => import('@/views/selfTtest/RecorData/bloodsugar.vue'),
		meta: {
			title: '血糖',
			keepAlive: true
		}
	},
	{
		// 体重
		path: '/weight',
		name: 'weight',
		component: () => import('@/views/selfTtest/RecorData/weight.vue'),
		meta: {
			title: '体重',
			keepAlive: true
		}
	},
	{
		// 运动
		path: '/sport',
		name: 'sport',
		component: () => import('@/views/selfTtest/RecorData/sport.vue'),
		meta: {
			title: '运动',
			keepAlive: true
		}
	},
  {
    // 其他
    path: '/other',
    name: 'other',
    component: () => import('@/views/selfTtest/RecorData/other.vue'),
    meta: {
      title: '其他',
      keepAlive: true
    }
  },
	{
		// 详情 其他监测
		path: '/smokeInfo',
		name: 'smokeInfo',
		component: () => import('@/views/selfTtest/detailInfo/smoke/smoke.vue'),
		meta: {
			title: '监测',
			keepAlive: true
		}
	},

  {
    // 详情 运动监测
    path: '/sportInfo',
    name: 'sportInfo',
    component: () => import('@/views/selfTtest/detailInfo/sport/sport.vue'),
    meta: {
      title: '监测',
      keepAlive: true
    }
  },
  {
    // 详情 体重监测
    path: '/weightInfo',
    name: 'weightInfo',
    component: () => import('@/views/selfTtest/detailInfo/weight/weight.vue'),
    meta: {
      title: '体重监测',
      keepAlive: true
    }
  },
  {
    // 详情 血糖监测
    path: '/bloodsugarInfo',
    name: 'bloodsugarInfo',
    component: () => import('@/views/selfTtest/detailInfo/bloodsugar/bloodsugar.vue'),
    meta: {
      title: '血糖监测',
      keepAlive: true
    }
  },
  {
    // 详情 血压监测
    path: '/recorInfo',
    name: 'recorInfo',
    component: () => import('@/views/selfTtest/detailInfo/recor/recor.vue'),
    meta: {
      title: '血压监测',
      keepAlive: true
    }
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routerPage/seltTest.js